export default "__VITE_ASSET__951ee21d__"